import api from './AxiosInstance';

export class ArticlesAchatService {
  getAllArticlesAchat = async () => {
    try {
      const response = await api.get(`/BonAchat/Articles/List`, {
      
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };


  addArticlesAchat = async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/BonAchat/Article/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateArticlesAchat = async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/BonAchat/Article/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteArticlesAchat= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/BonAchat/Article/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


